import SmoothScroll from "../components/site/SmoothScroll";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import BrandMarquee from "../components/site/Marquee";
import OrderApps from "../components/site/OrderApps";
import Manifesto from "../components/site/Manifesto";
import MenuGallery from "../components/site/Menu";
import Bento from "../components/site/Bento";
import Enquiry from "../components/site/Enquiry";
import Connect from "../components/site/Connect";
import Footer from "../components/site/Footer";

export default function Landing() {
  return (
    <SmoothScroll>
      <div className="grain relative min-h-screen bg-[#f7f0e0]">
        <Nav />
        <main>
          <Hero />
          <BrandMarquee />
          <OrderApps />
          <Manifesto />
          <MenuGallery />
          <Bento />
          <Enquiry />
          <Connect />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
